import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "../css/header.css";
import logo_colors from "../img/logo_colors.svg";
import logo_Blanco from "../img/logo_Blanco.svg";

export default function Header() {
  const location = useLocation();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const isActive = (path) => location.pathname === path;

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };
  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? "hidden" : "auto";
  }, [isMenuOpen]);
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);
  return (
    <section>
      <div
        className={`menu ${isActive("/") ? "home" : ""} ${
          isActive("/ourWork") ? "our-work" : ""
        }`}
      >
        {isActive("/") || isActive("/ourWork") ? (
          <Link to="/">
            <img
              src={logo_Blanco}
              alt="Panamarine Repair logo - marine engine service in Panama"
            />
          </Link>
        ) : (
          <Link to="/">
            <img
              src={logo_colors}
              alt="Panamarine Repair logo - marine engine service in Panama"
            />
          </Link>
        )}
        <div onClick={toggleMenu}>
          {isMenuOpen ? (
            <span className="close-icon">✕</span>
          ) : (
            <div
              className={`hamburguer-menu ${isActive("/") ? "home" : ""} ${
                isActive("/ourWork") ? "our-work" : ""
              }`}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
        <nav className={`menu-links ${isMenuOpen ? "open" : ""}`}>
          <Link
            to="/"
            className={`links-menu ${isActive("/") ? "home" : ""} ${
              isActive("/ourWork") ? "our-work" : ""
            }`}
            style={{ color: isActive("/") ? "#14F8AB" : "" }}
            id="menuHome"
          >
            Home
          </Link>
          <Link
            to="/services"
            className={`links-menu ${isActive("/") ? "home" : ""} ${
              isActive("/ourWork") ? "our-work" : ""
            }`}
            style={{ color: isActive("/services") ? "#18BAF7" : "" }}
            id="menuServices"
          >
            Services
          </Link>
          <Link
            to="/ourWork"
            className={`links-menu ${isActive("/") ? "home" : ""} ${
              isActive("/ourWork") ? "our-work" : ""
            }`}
            style={{ color: isActive("/ourWork") ? "#14F8AB" : "" }}
            id="menuOurWork"
          >
            Our work
          </Link>
          <Link
            to="/about"
            className={`links-menu ${isActive("/") ? "home" : ""} ${
              isActive("/ourWork") ? "our-work" : ""
            }`}
            style={{ color: isActive("/about") ? "#18BAF7" : "" }}
            id="menuAboutUs"
          >
            About us
          </Link>
          <Link
            to="/contact"
            className={`links-menu ${isActive("/") ? "home" : ""} ${
              isActive("/ourWork") ? "our-work" : ""
            }`}
            style={{ color: isActive("/contact") ? "#18BAF7" : "" }}
            id="menuContact"
          >
            Contact
          </Link>
        </nav>
      </div>
      <Outlet />
    </section>
  );
}
